module.exports = __webpack_public_path__ + "img/sponsors-05.af7ac150.png";